import "./Error.css";
import "./ErrorResponsive.css";

function Error() {
  return <div className="error-page">
    <div className="d-block text-center">
      <h1>404</h1>
      <p>Oops... We couldn't find the page</p>
    </div>
  </div>;
}

export default Error;
